import { NavLink } from "react-router";
import { useTranslation } from "../../hooks/useTranslation";

export default function ClaimRow({ claim }) {
  const { t } = useTranslation();

  const stateClass = {
    open: "badge-warning",
    in_progress: "badge-info",
    closed: "badge-success",
  };

  return (
    <tr>
      <td>
        <NavLink to={"/reklamace/" + claim.claim_id}>
          {claim.claim_id}
        </NavLink>
      </td>
      <td>
        <NavLink to={"/prilezitost/" + claim.opportunity_id}>
          {claim.opportunity_description}
        </NavLink>
      </td>
      <td>
        {claim.invoice_number || "-"}
      </td>
      <td>
        <span className={"badge " + (stateClass[claim.state] || "badge-secondary")}>
          {claim.state_name}
        </span>
      </td>
      <td>
        {claim.created_date
          ? new Date(claim.created_date).toLocaleDateString()
          : "-"}
      </td>
      <td>{claim.defect_description_short}</td>
      <td className="text-end">
        <NavLink
          className="btn btn-primary btn-sm"
          to={"/reklamace/" + claim.claim_id}
        >
          {t("common.detail")}
        </NavLink>
      </td>
    </tr>
  );
}
